export enum ToastTypeEnum {
  Info,
  Success,
  Error,
  Warning,
}

export enum ToastPositionEnum {
  TopLeft = 'top-left',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  BottomRight = 'bottom-right',
}
